<template>
    <footer>
        <p class="footer-text d-flex justify-content-center">Muhammad Valensyah Alfansyuri&copy; 2020</p>
    </footer>
</template>
<script>
export default {
    name: 'Footer'
}
</script>
<style lang="scss" scoped>
footer {
    padding: 15px 0px;
    .footer-text {
        color: white;
    }
    width: 100%;
    height: 50px;
    background: rgb(43, 40, 40);
}
</style>
